import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import WestIcon from "@mui/icons-material/West";
import EastIcon from "@mui/icons-material/East";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { BlobServiceClient } from "@azure/storage-blob";
import { useNavigate } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import { MyDocument } from './components/pdf.js';
const steps = ["Start", "Materiality", "Module", "Input", "Report"];

export default function PreviewReport() {
  const username = localStorage.getItem("userName");
  const companyid = localStorage.getItem("companyid");
  const organizationValue = localStorage.getItem('organization');
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [formData, setFormData] = useState({
    reportTitle: "",
    companyName: "",
    reportingYear: "",
    fileUrl : ""
  });
  const step1 = localStorage.getItem("step1");
  const reportName = JSON.parse(step1);
  const [showPDF, setShowPDF] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [reportData, setReportData] = useState(JSON.parse(localStorage.getItem("step4")) || []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      fileUrl: URL.createObjectURL(file),
    });
    setSelectedFile(file);
    setFileUrl(URL.createObjectURL(file));
    uploadFile("ecoprismfilecontainer", companyid, file); 
  };

  const getOpen = (open) => {
    setIsOpen(open);
  };

  const handleFormChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  async function uploadJsonFile(containerName, folderName, fileName, jsonData) {
    try {
      let res = await fetch("https://ecoprism-prod-node.azurewebsites.net/GetSASToken", {
        method: "GET",
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        }
      });

      if (res.status === 200) {
        const responseJson = await res.json();
        const connectionString = responseJson.data;

        const blobServiceClient = new BlobServiceClient(connectionString);
        const containerClient = blobServiceClient.getContainerClient(containerName);
        const blobName = `${folderName}/${fileName}.json`;
        const blobClient = containerClient.getBlobClient(blobName);
        const blockBlobClient = blobClient.getBlockBlobClient();
        const arrayBuffer = new TextEncoder().encode(JSON.stringify(jsonData));
        const uploadResponse = await blockBlobClient.uploadBrowserData(arrayBuffer.buffer, {
          blobHTTPHeaders: { blobContentType: 'application/json' },
          blockSize: 4 * 1024 * 1024,
          concurrency: 20,
          onProgress: (ev) => console.log(ev.loadedBytes)
        });
        if (uploadResponse) {
          console.log(`JSON file "${fileName}" uploaded successfully.`);
          console.log(`Blob URL: ${blobClient.url}`);
          localStorage.setItem("bloburl", blobClient.url);
        }
      } else {
        console.error("Failed to fetch SAS token.");
      }
    } catch (error) {
      console.error("Error uploading JSON file:", error);
    }
  }

  async function uploadFile(containerName, folderName, file) {
    try {
      let res = await fetch("https://ecoprism-prod-node.azurewebsites.net/GetSASToken", {
        method: "GET",
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        }
      });

      if (res.status === 200) {
        const responseJson = await res.json();
        const connectionString = responseJson.data;

        const blobServiceClient = new BlobServiceClient(connectionString);
        const containerClient = blobServiceClient.getContainerClient(containerName);
        const blobName = `${folderName}/${file.name}`;
        const blobClient = containerClient.getBlobClient(blobName);
        const blockBlobClient = blobClient.getBlockBlobClient();
        const uploadResponse = await blockBlobClient.uploadBrowserData(file, {
          blobHTTPHeaders: { blobContentType: file.type },
          blockSize: 4 * 1024 * 1024,
          concurrency: 20,
          onProgress: (ev) => console.log(ev.loadedBytes)
        });
        if (uploadResponse) {
          console.log(`File "${file.name}" uploaded successfully.`);
          console.log(`Blob URL: ${blobClient.url}`);
          localStorage.setItem("bloburl", blobClient.url);
        }
      } else {
        console.error("Failed to fetch SAS token.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  }


  const validateForm = () => {
    const newErrors = {};
    if (!formData.reportTitle) newErrors.reportTitle = 'Report Title is required';
    if (!formData.companyName) newErrors.companyName = 'Company Name is required';
    if (!formData.reportingYear) newErrors.reportingYear = 'Reporting Year is required';
    if (!formData.fileUrl) newErrors.fileUrl = 'Logo is required';
    
    setErrors(newErrors);
    return newErrors;
  };

  const handleSave = async() => {
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    setLoading(true);
   
    const step1 = localStorage.getItem("step1");
    const step2 = localStorage.getItem("step2");
    const step3 = localStorage.getItem("step3");
    const step4 = localStorage.getItem("step4");
    const hash = localStorage.getItem("hash");
    const organizationValue = localStorage.getItem('organization');
    const username = localStorage.getItem('userName');
    const parseData = JSON.parse(step1);

    const rdata = {
      name: parseData.name,
      timeline: parseData.timeline,
      legalEntity: parseData.legalEntity,
      startDate: parseData.startDate,
      endDate: parseData.endDate,
      materiality: JSON.parse(step2),
      reportingModule: JSON.parse(step3),
      generateReport: JSON.parse(step4)
    };
    uploadJsonFile("ecoprismfilecontainer",companyid,hash,rdata);
    // if (selectedFile) {
    //   await uploadFile("ecoprismfilecontainer", companyid, selectedFile);
    // }
    setSuccessMessage("Data Updated Successfully");
    setLoading(false);
    setShowPDF(true);
    
  };

  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      <div id="sidebar-wrapper" className={isOpen ? "sidebar-open" : "sidebar-close"}>
        <SideNavigation getOpen={getOpen} />
      </div>
      <div id="page-content-wrapper" className={isOpen ? "" : "page-content-wrapper-pd-0"}>
        <LoginHeader heading="" />
        <div className="container formpd">
          <div className="flex justify-content-between">
            <div className="steps__containt-hader">
              <h3 className="title">{ reportName.name }</h3>
              <div role="presentation">
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                >
                  <Link underline="hover" color="inherit" href="/standards">
                    Reports
                  </Link>
                  <Link underline="hover" color="inherit" href="/standards">
                    Standards & Frameworks
                  </Link>
                  <Link underline="hover" color="inherit" href="/csrd">
                    CSRD
                  </Link>
                  <Link underline="hover" color="inherit" href="/GenerateReport">
                    { reportName.name }
                  </Link>
                  <Typography color="text.primary">Preview Report</Typography>
                </Breadcrumbs>
              </div>
            </div>
            <div className="stepper-box">
              <Stepper activeStep={4} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel className="step-name">{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </div>
          </div>
          <div>
            <div className="button-box d-flex justify-content-end">
              <Button
                onClick={() => navigate('/GenerateReport')}
                variant="outlined"
                className="module-btn"
                size="medium"
                sx={{ marginRight: "15px" }}
              >
                <WestIcon fontSize="small" sx={{ marginRight: "4px" }} />
                Input
              </Button>
              <Button
                onClick={() => navigate('/reportDashboard')}
                variant="outlined"
                className="module-btn"
                size="medium"
                sx={{ marginRight: "15px" }}
              >
                <img src="/assets/img/reports/Status.svg" style={{ marginRight: "4px" }} />
                Status
              </Button>
              <Button 
                onClick={handleSave} 
                variant="outlined" 
                className="module-btn" 
                size="medium"
              >
                Generate Report 
                <EastIcon fontSize="small" sx={{ marginLeft: "4px" }} />
              </Button>
            </div>
            <div className="col-md-12 mt-4 pd-0">
              <form action="">
                <div className="form-row">
                  {successMessage && (
                    <div className="alert alert-success" role="alert">
                      {successMessage}
                    </div>
                  )}
                </div>
                <div className="form-row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="formlable" htmlFor="reportTitle">
                        Report Title
                      </label>
                      <input
                        type="text"
                        required
                        className={`form-control wd-85 ${errors.reportTitle ? 'is-invalid' : ''}`}
                        name="reportTitle"
                        placeholder="Enter the report title"
                        value={formData.reportTitle}
                        onChange={handleFormChange}
                      />
                      {errors.reportTitle && <div className="text-danger">{errors.reportTitle}</div>}
                    </div>
                    <div className="form-group">
                      <label className="formlable" htmlFor="companyName">
                        Company Name
                      </label>
                      <input
                        type="text"
                        required
                        className={`form-control wd-85 ${errors.companyName ? 'is-invalid' : ''}`}
                        name="companyName"
                        placeholder="Enter Company name"
                        value={formData.companyName}
                        onChange={handleFormChange}
                      />
                      {errors.companyName && <div className="text-danger">{errors.companyName}</div>}
                    </div>
                    <div className="form-group">
                      <label className="formlable" htmlFor="reportingYear">
                        Reporting Year
                      </label>
                      <input
                        type="text"
                        required
                        className={`form-control wd-85 ${errors.reportingYear ? 'is-invalid' : ''}`}
                        name="reportingYear"
                        placeholder="Enter year"
                        value={formData.reportingYear}
                        onChange={handleFormChange}
                      />
                      {errors.reportingYear && <div className="text-danger">{errors.reportingYear}</div>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="formlable" htmlFor="companyLogo">
                        Company Logo
                      </label>
                      <div className="upload-section">
                        <input 
                          type="file" 
                          id="companyLogo" 
                          accept="image/*" 
                          name="fileUrl"
                          style={{ display: "none" }} 
                          onChange={handleFileChange}
                        />
                        <label htmlFor="companyLogo" className="upload-box">
                          <img src="/assets/img/reports/Upload.svg" />
                          <span className="upload-text">
                            Upload logo or drag and drop the file here
                          </span>
                        </label>
                      </div>
                      {errors.fileUrl && <div className="text-danger">{errors.fileUrl}</div>}
                      {fileUrl && (
                        <div className="file-preview">
                          <img src={fileUrl} alt="Company Logo" style={{ maxWidth: '200px', marginTop: '10px' }} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="row justify-content-end pt-3">
              <div className="col-auto">
                <Button
                  onClick={handleSave}
                  className="next-button"
                  variant="contained"
                  size="medium"
                  sx={{ width: "auto", padding: " 0 30px !important", marginBottom:"30px" }}
                >
                  Preview Report
                </Button>
              </div>
            </div>
            {showPDF && (
              <div style={{ width: '100%', height: '100vh' }}>
                <PDFViewer style={{ width: '100%', height: '100%' }}>
                  <MyDocument 
                    reportData={reportData}
                    reportTitle={formData.reportTitle} 
                    companyLogo={fileUrl}
                  />
                </PDFViewer>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
